import { Data, UI } from '@taraai/types';

export const getCommitKey = (commit: UI.UICommit | Data.Commit | UI.UICommitSummary): string => {
  if (commit && commit.sha) {
    return commit.sha.slice(0, 7);
  }
  return '';
};
